import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import api from "@/lib/api";
import { startPoll } from "@/lib/poll";

function PileModal({ onClose }) {
  const [pile, setPile] = useState(null);
  useEffect(() => {
    const fetchPile = () => api.get("/pile-stats").then(({ data }) => setPile(data)).catch((e) => console.debug("pile", e));
    fetchPile();
    return startPoll(fetchPile, 4000);
  }, []);
  return (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-6 fade-in overflow-y-auto"
          style={{ background: "rgba(0,0,0,0.7)" }}
          onClick={() => onClose()}
          data-testid="pile-overlay"
        >
          <div
            className="w-full max-w-md p-8 my-auto"
            style={{ background: "var(--bg-modal)", border: "1px solid var(--border)" }}
            onClick={(e) => e.stopPropagation()}
            data-testid="pile-modal"
          >
            <div className="flex justify-between items-start mb-6">
              <span className="text-xs uppercase tracking-widest" style={{ color: "var(--text-muted)" }}>
                the pile
              </span>
              <button
                onClick={() => onClose()}
                data-testid="pile-close-btn"
                className="text-sm opacity-60 hover:opacity-100"
                style={{ color: "var(--text-primary)" }}
              >
                [ close ]
              </button>
            </div>

            <div className="flex justify-center gap-10 mb-2">
              <div className="text-center">
                <div className="text-2xl font-head font-light" style={{ color: "var(--text-primary)" }} data-testid="pile-asks">
                  {(pile?.asks ?? 0).toLocaleString()}
                </div>
                <div className="text-xs tracking-widest uppercase" style={{ color: "var(--text-muted)" }}>asks</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-head font-light" style={{ color: "var(--text-primary)" }} data-testid="pile-answers">
                  {(pile?.answers ?? 0).toLocaleString()}
                </div>
                <div className="text-xs tracking-widest uppercase" style={{ color: "var(--text-muted)" }}>answers</div>
              </div>
            </div>

            <div className="text-center mb-1" data-testid="pile-total">
              <span className="text-3xl font-head font-light" style={{ color: "var(--accent)" }}>
                {(pile?.total ?? 0).toLocaleString()}
              </span>
              <span className="text-sm tracking-widest" style={{ color: "var(--text-muted)" }}> / {(pile?.threshold ?? 100).toLocaleString()}</span>
            </div>

            <div className="text-center mb-6" data-testid="pile-level">
              <span className="text-xs tracking-widest uppercase" style={{ color: "var(--text-muted)" }}>
                level {pile?.level ?? 1}
              </span>
            </div>

            <div
              data-testid="pile-bar"
              className="w-full h-4 overflow-hidden"
              style={{ border: "1px solid var(--border)", background: "rgba(90,90,90,0.15)" }}
            >
              <div
                data-testid="pile-bar-fill"
                className="h-full"
                style={{
                  width: `${Math.min(100, ((pile?.total ?? 0) / (pile?.threshold ?? 100)) * 100)}%`,
                  background: "var(--accent)",
                  transition: "width 0.6s ease",
                }}
              />
            </div>

            <p className="text-xs mt-4 tracking-widest text-center" style={{ color: "var(--text-muted)" }} data-testid="pile-revolution">
              level 11...
            </p>
          </div>
        </div>
  );
}

export function PileButton() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="the-pile-btn" className="btn px-6 py-2 text-xs tracking-widest">THE PILE</button>
      {open && createPortal(<PileModal onClose={() => setOpen(false)} />, document.body)}
    </>
  );
}
